export default __webpack_public_path__ + "static/media/3.7dd52444.jpg";